import { fromJS } from 'immutable';
import { normalizeItems } from '@Utils';
import { breadcrumbsRetrievedType } from './BreadcrumbsConstants';

export const initialState = fromJS({
  ids: [],
  items: {},
});

// eslint-disable-next-line default-param-last
export default function breadcrumbsReducer(state = initialState, action) {
  // Use explicit if-checks instead of a switch for readability.
  // Use optional chaining to comply with the `no-unsafe-deep-access` lint rule.
  if (action?.type === breadcrumbsRetrievedType) {
    const { breadcrumbs } = action;
    const normalized = normalizeItems(breadcrumbs);

    return state.merge(
      fromJS({
        ids: normalized.ids,
        items: normalized.items,
      })
    );
  }

  return state;
}
